import {
  blue,
  CoordinatesIcon,
  FaroText,
  grey,
} from "@faro-lotv/app-component-toolbox";
import { Box, Stack, SxProps, Theme } from "@mui/material";
import type { JSX } from "react";

type ControlPointsAlignmentDescriptionProps = {
  /** Optional style to apply to the list. */
  sx?: SxProps<Theme>;
};
/** @returns render description of control-points alignment */
export function ControlPointsAlignmentDescription({
  sx,
}: ControlPointsAlignmentDescriptionProps): JSX.Element {
  // Shared styles
  const textStyles = {
    fontFamily: "Open Sans",
    fontSize: 14,
    lineHeight: "20px",
    p: 3,
  };

  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "100%",
        ...sx,
      }}
    >
      <Box
        component="div"
        sx={{
          border: 2,
          borderColor: grey[300],
          mr: "48px",
          ml: "48px",
          height: "300px",
        }}
      >
        <Stack direction="row" sx={{ width: "100%", height: "100%" }}>
          <Box
            component="div"
            sx={{
              width: "30%",
              height: "100%",
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <Stack
              direction="column"
              sx={{
                justifyContent: "center",
                width: "100%",
                height: "100%",
                backgroundColor: grey[50],
              }}
            >
              <Box
                component="div"
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <CoordinatesIcon
                  sx={{
                    width: "80%",
                    height: "80%",
                    color: grey[600],
                  }}
                />
              </Box>
              <FaroText
                variant="labelM"
                fontWeight={400}
                align="center"
                color={blue[400]}
                {...textStyles}
              >
                Align your sheet with only 2 clicks!
              </FaroText>
            </Stack>
          </Box>

          <Box component="div" sx={{ width: "70%", height: "100%" }}>
            <Stack
              direction="column"
              sx={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <FaroText
                variant="heading16"
                fontWeight={600}
                fontSize={16}
                lineHeight="24px"
                sx={{ pb: 1, pl: 3 }}
              >
                Control points alignment
              </FaroText>
              <FaroText
                variant="bodyM"
                fontWeight={400}
                {...textStyles}
                sx={{ pt: 1 }}
              >
                Align your floor plan with precision: Select two points on your
                sheet and enter their X, Y, and Z coordinates to ensure accurate
                alignment.
              </FaroText>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}
